import {
  CME_COLOUR_LENGTH,
  CME_INTERIOR_TRIM_LENGTH,
  CME_MATERIAL_CODE_LENGTH,
  CME_MVOB_LENGTH,
  CME_OPTIONSET_ACCESSORIES,
} from "../modules/Data/static";

import type { iInitConfig } from "../modules/Data/types";

const extractValuesByLengths = (string: string, lengths: number[]): string[] => {
  const values: string[] = [];
  let startIndex = 0;
  for (const length of lengths) {
    const value = string.substring(startIndex, startIndex + length);
    values.push(value);
    startIndex += length;
  }
  return values;
};

export const getConfigFromMaterialCode = (
  materialCode?: string,
): iInitConfig | undefined => {
  if (materialCode?.length === CME_MATERIAL_CODE_LENGTH) {
    const [mvob, interiorTrim, colour] = extractValuesByLengths(materialCode, [
      CME_MVOB_LENGTH,
      CME_INTERIOR_TRIM_LENGTH,
      CME_COLOUR_LENGTH,
    ]);

    return { mvob, interiorTrim, colour };
  }
};

export const getCMEAccessoriesToDisplay = (cmeOptions: any) =>
  cmeOptions?.optionsToDisplay?.get(CME_OPTIONSET_ACCESSORIES) || [];

export const getSelectedAccessories = (cmeOptions: any) =>
  cmeOptions?.selectedOptions?.get(CME_OPTIONSET_ACCESSORIES) || [];

export const getSiloProductAndVersion = (siloManifest: any) => {
  const { silo_id } = siloManifest;
  const match = silo_id.match(/^(\w+?)_(\d{4}_\d{2})$/);

  let productId: string | undefined;
  let version: string | undefined;

  if (match) {
    productId = match[1]; // vehicle name
    version = match[2]; // silo version (e.g. 2025_01)
  }

  return { productId, version };
};
